import { render } from "./ItalladdsView.vue?vue&type=template&id=0d782593"
import script from "./ItalladdsView.vue?vue&type=script&lang=js"
export * from "./ItalladdsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__